import { ConfirmationModal } from '@shared/components';

import { EXTEND_TYPE, type ExtendTimeFormType } from './schema';

export interface ExtendTimeConfirmationModalProps {
  open: boolean;
  values: ExtendTimeFormType | null;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

function getConfirmationContent(values: ExtendTimeFormType | null) {
  if (!values?.amount) {
    return '';
  }

  const extendTargetLabel =
    values.extendType === EXTEND_TYPE.EXAMINEE
      ? `ผู้เข้าสอบที่เลือกไว้ทั้งหมด ${values.examineeIds?.length ?? 0} คน`
      : 'ผู้เข้าสอบทุกคนในรอบสอบนี้';

  return `ทดเวลาไม่เกิน ${values.amount} นาที ให้${extendTargetLabel}`;
}

export default function ExtendTimeConfirmationModal(
  props: Readonly<ExtendTimeConfirmationModalProps>,
) {
  const { open, values, onClose, onConfirm, loading = false } = props;

  return (
    <ConfirmationModal
      title='ยืนยันการทดเวลาสอบ'
      content={getConfirmationContent(values)}
      open={open}
      loading={loading}
      onAccept={onConfirm}
      onDiscard={onClose}
      onClose={onClose}
    />
  );
}
